import { useEffect, useRef, useState } from 'react';
import { isClientSide } from '~/src/helpers/ssr';

/**
 * @param {function} callBack - вызываемя функция
 * @param {Node|null} root - dom Элемент который используется в качестве
 *     области просмотра для проверки видимости целевого элемента
 * @param {string} rootMargin - Отступы вокруг root.  Могут иметь значения как
 *     свойство css margin: "10px 20px 30px 40px" (top, right, bottom, left).
 *     Значения можно задавать в процентах.
 * @param {number|number[]} threshold - Число или массив чисел, указывающий,
 *     при каком проценте видимости целевого элемента должен сработать
 *     callback.
 * @return {function(value: Node):undefined}
 */
export const useIntersectionObserver = (
    callBack: IntersectionObserverCallback,
    { root = null, rootMargin, threshold = 0 }: IntersectionObserverInit,
): React.Dispatch<React.SetStateAction<Element | null>> => {
    // ссылка на элемент за которым будем/уже след -ить/-им
    const [node, setNode] = useState<Element | null>(null);

    let observerInst = null;
    if (isClientSide()) {
        observerInst = new window.IntersectionObserver(callBack, {
            root,
            rootMargin,
            threshold,
        });
    }

    const observer = useRef(observerInst);

    useEffect(
        () => {
            if (observer.current && node) {
                const { current: currentObserver } = observer;
                // отсоединяемся от предыдущего элемента
                currentObserver.disconnect();

                if (node) {
                    // следим за текущем
                    currentObserver.observe(node);
                }
                // при отмонтировании отписываемся
                return () => {
                    currentObserver.disconnect();
                };
            }
        },
        [node],
    );

    return setNode;
};
